import Drawer, { DrawerProps } from "@mui/material/Drawer";
import { EmtTypography } from "./EmtTypography";

export type EmtDrawerProps = DrawerProps & {
  /**
   * Top drawer title
   */
  title?: string;
  /**
   * Set if drawer is on top of all page
   * @default true
   */
  onTop?: boolean;
};

export function EmtDrawer(props: EmtDrawerProps) {
  const {
    title,
    children,
    open,
    variant = "persistent",
    anchor = "left",
    onTop = true,
    sx,
    PaperProps,
    ...rest
  } = props;
  return (
    <Drawer
      anchor={anchor}
      variant={variant}
      sx={{ zIndex: onTop ? 9200 : 1200 }}
      PaperProps={{
        ...(PaperProps ? PaperProps : {}),
        sx:
          variant === "temporary"
            ? {
                padding: "0 20px",
                height: "100%",
                backgroundColor: "background.default",
                ...sx,
              }
            : {
                paddingLeft: "48px",
                paddingRight: "35px",
                minWidth: "380px",
                ...sx,
              },
      }}
      open={open}
      {...rest}
    >
      {title && (
        <EmtTypography
          variant="h4"
          fontWeight="bold"
          sx={{ userSelect: "none" }}
        >
          {title}
        </EmtTypography>
      )}

      {children}
    </Drawer>
  );
}
